"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";
import "./modalContext.scss";
import { TimesIcon } from "@/icons";
import Draggable from "react-draggable";

interface ShowAnswerContextProps {
  showAnswer: (id: string, title: string, answer: string) => void;
  closeAnswer: () => void;
}

const ShowAnswerContext = createContext<ShowAnswerContextProps | undefined>(
  undefined
);

export const ShowAnswerContextProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [answer, setAnswer] = useState<string | null>(null);
  const [currentModalId, setCurrentModalId] = useState<string>("");
  const [title, setTitle] = useState("");

  const showAnswer = (id: string, title: string, answer: string) => {
    if (currentModalId === id) {
      closeAnswer();
      return;
    }
    if (isOpen) {
      closeAnswer();
    }
    setTitle(title);
    setAnswer(answer);
    setCurrentModalId(id);
    setTimeout(() => {
      setIsOpen(true);
    }, 100);
  };

  const closeAnswer = () => {
    setIsOpen(false);
    setCurrentModalId("");
    setAnswer(null);
  };

  return (
    <ShowAnswerContext.Provider value={{ showAnswer, closeAnswer }}>
      {children}
      {isOpen && (
        <Draggable cancel=".close-button, .modal-header">
          <div
            className={`modal open`}
            style={{
              top: "30%",
              left: "30%",
              transform: "translate(-50%, -50%) !important",
              position: "absolute",
            }}
          >
            <div className="modal-header">
              <span className="modal-header-text">{title}</span>
              <button className="close-button" onClick={() => closeAnswer()}>
                <TimesIcon className={undefined} />
              </button>
            </div>
            <div className="modal-content">{answer}</div>
          </div>
        </Draggable>
      )}
    </ShowAnswerContext.Provider>
  );
};

export const useShowAnswer = () => {
  const context = useContext(ShowAnswerContext);
  if (!context) throw new Error("useModal must be used within a ModalProvider");
  return context;
};
